import React from "react";
import "./TableBlock.scss";

const TableBlock = ({ columns, rows, block_id, section_id, report_id }) => (
    <div
        className="Table-Wrapper"
        id={block_id || undefined}
        data-block-id={block_id || undefined}
        data-section-id={section_id || undefined}
        data-report-id={report_id || undefined}
    >
        <table className="table-block">
            <thead>
                <tr>
                    {columns.map((col, i) => <th key={i}>{col}</th>)}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rIdx) => (
                    <tr key={rIdx}>
                        {row.map((cell, cIdx) => <td key={cIdx}>{cell}</td>)}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default TableBlock;
